var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section-layout',{attrs:{"centered":true}},[_c('v-img',{staticClass:"home-background",attrs:{"src":require('@/assets/images/home/ikone-background.jpg')}}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }